import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import UserDetailPage from './pages/UserDetailPage';
import ChatDetailPage from './pages/ChatDetailPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import BillingQuotaConfigPage from './pages/BillingQuotaConfigPage';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import authService from './services/auth';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check authentication status
    authService.isAuthenticated() && authService.isAdmin();
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:userId" element={<UserDetailPage />} />
        <Route path="chats/:chatId" element={<ChatDetailPage />} />
        <Route path="billing-quotas" element={<BillingQuotaConfigPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;

